import approval, { IApprovalApi } from './approval'
import auth, { IAuthAPI } from './auth'
import common, { ICommonAPI } from './common'
import employee, { IEmployeeAPI } from './employee'
import hr, { IHrApi } from './hr'
import supervisor, { ISupervisorAPI } from './supervisor'

export interface IAPI {
  approval: IApprovalApi
  auth: IAuthAPI
  common: ICommonAPI
  employee: IEmployeeAPI
  hr: IHrApi
  supervisor: ISupervisorAPI
}

export default {
  approval,
  auth,
  common,
  employee,
  hr,
  supervisor,
}
